const clearFilterButton = {
  Typography: 'Borrar Todos'
};

export default clearFilterButton;
